/* CUSTOM : SIZE DROPDOWN */
(() => {
  const PAGES = [
    'https://www.roverpetproducts.com.au/products/tuffmat-durable-orthopedic-bed-for-dogs',
    'https://www.roverpetproducts.com.au/products/plushmat-orthopedic-dog-bed',
    'https://www.roverpetproducts.com.au/products/boucle-plushmat',
    'https://www.roverpetproducts.com.au/products/plushmatplus',
  ];
  const pageIsAllowed = PAGES.some((entry) =>
    entry instanceof RegExp
      ? entry.test(location.pathname)
      : (entry.startsWith('http') ? location.href : location.pathname)
          .toLowerCase() === entry.toString().toLowerCase()
  );
  if (!pageIsAllowed) return;

  const DROPDOWNS = [
    {
      selector: '#option-0',
      name: 'options[Size]',
      customText: 'Custom',
      customURL:
        'https://www.roverpetproducts.com.au/pages/custom-size-dog-beds',
    },
    {
      selector: '#option-1',
      name: 'options[Size]',
      customText: 'Custom',
      customURL:
        'https://www.roverpetproducts.com.au/pages/custom-size-dog-beds',
    },
  ];

  const isURL = (s) => /^https?:\/\//i.test(s) || s.startsWith('/');

  const addCustomOption = (sel, { customText, customURL }) => {
    const exists = Array.from(sel.options).some(
      (o) => o.dataset.jump === customURL
    );
    if (exists) return;

    const opt = new Option(customText, 'custom');
    opt.dataset.jump = customURL;
    sel.add(opt);
  };

  const bind = (sel) => {
    if (sel.dataset.jumpLinked) return;
    sel.dataset.jumpLinked = '1';

    sel.addEventListener(
      'change',
      (e) => {
        const opt = e.target.options[e.target.selectedIndex];
        const url = opt.dataset.jump || (isURL(opt.value) ? opt.value : null);

        if (url) {
          e.stopImmediatePropagation();
          location.href = url;
        }
      },
      { passive: true, capture: true }
    );
  };

  const upgrade = (sel, cfg) => {
    if (
      (cfg.name || '').toLowerCase() !==
      (sel.getAttribute('name') || '').toLowerCase()
    )
      return;
    addCustomOption(sel, cfg);
    bind(sel);
  };

  const scan = () =>
    DROPDOWNS.forEach((cfg) =>
      document.querySelectorAll(cfg.selector).forEach((sel) => upgrade(sel, cfg))
    );

  document.readyState !== 'loading'
    ? scan()
    : document.addEventListener('DOMContentLoaded', scan, { once: true });

  new MutationObserver((ms) =>
    ms.forEach((m) =>
      m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        DROPDOWNS.forEach((cfg) => {
          if (n.matches?.(cfg.selector)) upgrade(n, cfg);
          n
            .querySelectorAll?.(cfg.selector)
            .forEach((sel) => upgrade(sel, cfg));
        });
      })
    )
  ).observe(document.body, { childList: true, subtree: true });
})();

/* CUSTOM : PRODUCTBOXES */
(function () {
  const TARGET_URL = 'https://www.roverpetproducts.com.au/pages/custom-size-dog-beds';
  const SELECTOR = '.productboxes .productboxes--selector';

  function injectAll() {
    let changed = false;
    document.querySelectorAll(SELECTOR).forEach(wrap => {
      if (wrap.querySelector('[data-custom-btn]')) return;

      const template = wrap.querySelector('button');
      if (!template) return;

      const btn = template.cloneNode(true);
      btn.textContent = 'Custom';
      btn.removeAttribute('@click');
      btn.removeAttribute('x-bind:style');
      btn.removeAttribute('style');
      btn.dataset.customBtn = '1';
      btn.addEventListener('click', e => {
        e.preventDefault();
        window.location.href = TARGET_URL;
      });

      wrap.appendChild(btn);
      changed = true;
    });
    return changed;
  }

  function needsInjection() {
    return Array.from(document.querySelectorAll(SELECTOR))
      .some(wrap => !wrap.querySelector('[data-custom-btn]'));
  }

  injectAll();

  if (needsInjection()) {
    const mo = new MutationObserver(() => {
      if (injectAll() && !needsInjection()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();